const ROUTE_BUILDERS = {
  risk: (itemId) => `/risks/${itemId}`,
  control: (itemId) => `/controls/${itemId}`,
  action: (itemId) => `/actions/${itemId}`,
  incident: (itemId) => `/incidents/${itemId}`,
  tenant_policy: (itemId) => `/catalog/policies/${itemId}`,
  boardback: (itemId) => `/boardbacks/${itemId}`,
  audit_engagement: (itemId) => `/audit/audits/${itemId}`,
  audit_universe: (itemId) => `/audit-universe/${itemId}`,
  kpi: (itemId) => `/kpis/${itemId}`,
};

export const buildPinnedItemRoute = (itemType, itemId) => {
  const builder = ROUTE_BUILDERS[itemType];
  return typeof builder === "function" ? builder(itemId) : null;
};

export const getPinnedItemModuleLabel = (itemType) =>
  ({
    risk: "Risk",
    control: "Control",
    action: "Action",
    incident: "Incident",
    tenant_policy: "Tenant Policy",
    boardback: "Board Pack",
    audit_engagement: "Audit",
    audit_universe: "Auditable Entity",
    kpi: "KPI",
  }[itemType] || itemType);
